import { render, staticRenderFns } from "./HistoricoPlanosModal.vue?vue&type=template&id=11420e70"
import script from "./HistoricoPlanosModal.vue?vue&type=script&lang=js"
export * from "./HistoricoPlanosModal.vue?vue&type=script&lang=js"
import style0 from "./HistoricoPlanosModal.vue?vue&type=style&index=0&id=11420e70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports